export default {
  layouts: {
    innerHeight: window.innerHeight,
    appHeaderHeight: 0,
    appBodyPosition: 0,
    footerHeight: 0,
    padding: 0
  },
  create: {
    isActive: false,
    title: "default create"
  },
  edit: {
    isActive: false,
    title: "default create"
  },
  navigations: {
    list: [],
    active: "",
    action: {
      defaultAction: true,
      buttonTitle: "Buat"
    },
    refetchBadge: false
  },
  header: {
    title: "App",
    subtitle: ""
  },
  search: {
    query: "",
    onSearch: false
  },
  filter: {
    isActive: false,
    forms: [],
    selected: {},
    input: {
      type: "",
      query: ""
    },
    list: []
  },
  showDetail: false,
  profile: {
    detail: {},
    avatar: ''
  },
  notification: {
    reloadData: false
  }
};
